import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLightdark = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 198 36",
	style: { enableBackground: "new 0 0 198 36" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n	.st1{fill:#075A77;}\n	.st2{fill:#5FDDBC;}\n	.st3{fill:#6EB21F;}\n	.st4{fill:#D8B403;}\n	[data-theme=\"light\"] .st0,\n	.chakra-ui-light .st0{fill:#000000;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M38,10.6v14.9h-1.5V10.6H38z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M45.4,25.4V10.6h2.1c2.2,3.5,7.3,11.4,8.2,13h0c-0.1-2-0.1-4.3-0.1-6.7v-6.3h1.5v14.9h-2 c-2.1-3.3-7.3-11.7-8.3-13.3h0c0.1,1.8,0.1,4.2,0.1,6.8v6.5H45.4z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M67.5,11.9h-4.9v-1.3H74l-1.3,1.3h-3.6v13.5h-1.5V11.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M88.3,18.3h-7.5v5.8h8.2l-0.2,1.3h-9.5V10.6h9.4l-1.3,1.3h-6.6v5h7.5V18.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M95.1,25.4V10.6h2.1c2.2,3.5,7.3,11.4,8.2,13h0c-0.1-2-0.1-4.3-0.1-6.7v-6.3h1.5v14.9h-2 c-2.1-3.3-7.3-11.7-8.3-13.3h0c0.1,1.8,0.1,4.2,0.1,6.8v6.5H95.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M117.2,11.9h-4.9v-1.3h11.4l-1.3,1.3h-3.6v13.5h-1.5V11.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M129.5,21.4c0.4,1.9,1.7,3,4,3c2.5,0,3.5-1.2,3.5-2.8c0-1.6-0.7-2.5-3.9-3.3c-3.3-0.8-4.6-1.9-4.6-4 c0-2.1,1.5-3.9,4.8-3.9c3.4,0,4.8,2,5,3.9h-1.6c-0.3-1.5-1.3-2.6-3.5-2.6c-2,0-3.1,0.9-3.1,2.5c0,1.5,0.9,2.1,3.6,2.8 c4.2,1,4.9,2.7,4.9,4.5c0,2.3-1.7,4.2-5.2,4.2c-3.7,0-5.2-2.1-5.5-4.2H129.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M146.5,10.6v14.9h-1.5V10.6H146.5z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M153.9,10.6h9.2l-1.3,1.3h-6.4v5.3h7.3v1.3h-7.3v6.9h-1.5V10.6z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M173.2,25.4v-5.5c0-0.1,0-0.3-0.1-0.4l-5.3-9h1.8c1.4,2.5,3.8,6.6,4.5,7.8c0.6-1.2,3.1-5.3,4.6-7.8h1.6 l-5.5,9c0,0.1-0.1,0.2-0.1,0.3v5.5H173.2z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "st1",
				points: "12.3,26.3 10.4,28 10.4,18.1 12.3,16.3  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "st2",
				points: "17.7,26.3 15.8,28 15.8,15.4 17.7,13.7  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "st3",
				points: "23.1,26.3 21.2,28 21.2,12.6 23.1,10.8  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "st4",
				points: "28.6,26.3 26.6,28 26.6,9.7 28.6,8  "
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M184.3,11h-0.7v-0.2h1.6V11h-0.7v1.8h-0.3V11z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M187.3,12c0-0.4,0-0.8,0-1h0c-0.1,0.3-0.4,1.2-0.7,1.8h-0.2c-0.2-0.5-0.5-1.5-0.6-1.9h0c0,0.2,0,0.7,0,1v0.8 h-0.3v-2h0.4c0.2,0.6,0.5,1.4,0.6,1.7h0c0-0.2,0.4-1.1,0.6-1.7h0.4v2h-0.3V12z"
		})] })
	] })]
});
export default SvgLogoLightdark;
